import React, { Fragment } from "react";
import { OverheaderContainer, SocialsGroup } from "./header-styles";
import { IconLink } from "../icon-link/IconLink";
import logoFacebook from "@iconify/icons-carbon/logo-facebook";
import instagramFilled from "@iconify/icons-ant-design/instagram-filled";
import youtubeFill from "@iconify/icons-akar-icons/youtube-fill";

export const Overheader = () => {
  return (
    <Fragment>
      <OverheaderContainer>
        <SocialsGroup>
          <IconLink url="https://www.facebook.com/organicaudiostudio" icon={logoFacebook} />
          <IconLink url="https://www.instagram.com/organicaudiostudio/" icon={instagramFilled} />
          <IconLink
            url="https://www.youtube.com/channel/UCPPDd7b1bDV5xHrroN3-7jg"
            icon={youtubeFill}
            size="28px"
          />
        </SocialsGroup>
      </OverheaderContainer>
    </Fragment>
  );
};
